import './Header.css';

import React from 'react'

function Header() {
  return (
    <div className = "header_container">
        <div className = "nav">
             <a href="#home">Home</a>
             <a href="#about">About</a>
             <a href="#skills">Skills</a>
             <a href="#projects">Projects</a>
        </div>
    </div>
  )
}

export default Header